$('.leia-mais-depo').on('click', function () {
    // Obter o contexto do botão clicado
    const conteudo = $(this).closest('.col-10').find('.conteudo-seis-linhas');

    // Alternar as classes apenas no conteúdo relacionado
    conteudo.toggleClass('conteudo');
    conteudo.toggleClass('expandido');

    // Alterar o texto do botão baseado no estado do conteúdo
    if (conteudo.hasClass('expandido')) {
        $(this).text('Menos');
    } else {
        $(this).text('Leia mais');
    }
});